import { Box, Flex, Image, UnorderedList } from "@chakra-ui/react";
import MainMenuItem from "../MainMenuItem";
import Logo from "components/elements/Logo";
import { getCompanyUrl } from "utils/uiconfighelper";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useSidebarItems } from "./use-sidebar-items";

export default function Sidebar() {
  const { user } = useTenant();
  const { items } = useSidebarItems();

  const onLogoClick = () => {
    const companyWebsite = getCompanyUrl(user);

    if (companyWebsite) {
      window.open(companyWebsite, "_blank");
    }
  };

  if (!user) {
    return null;
  }

  return (
    <Flex direction="column" gap={4}>
      {user.company.logo || (user.lender_company && user.lender_company.logo) ? (
        <Box px={4} pt={6}>
          <Image
            src={user.company.logo || (user.lender_company && user.lender_company.logo)}
            title={user.company.name}
            onClick={onLogoClick}
            cursor="pointer"
          />
        </Box>
      ) : (
        <Logo />
      )}
      <UnorderedList listStyleType="none">
        {user.type === "lender" &&
          items.lender.map(item => <MainMenuItem key={item.path} item={item} />)}

        {user.type === "borrower" &&
          items.borrower.map(item => <MainMenuItem key={item.path} item={item} />)}
      </UnorderedList>
    </Flex>
  );
}
